import { RoutesKeys } from './../../utils/routes';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { User } from '../models/user/user';
import { LocalStorageKeys } from '../models/constants/storage.keys';
import { AuthenticatedUserService } from 'src/app/core/services/authenticated-user/authenticated-user.service';
import { UserService } from 'src/app/core/api/user/user.service';
import { Representative } from '../models/dtos/register-form/representative/representative';
import { Routes } from 'src/app/account-migration/routes';

@Injectable()
/**
 * User status guard will verify if the user had complete registration before proceeding to the next page
 */
export class UserStatusGuard {
  /**
   * Injects angular router
   * @constructor
   */
  constructor(
    private router: Router,
    private authenticatedUserService: AuthenticatedUserService,
    private userService: UserService
  ) {}

  /**
   * Method that check if the user had complete registration
   * @return {boolean}
   */
  canActivate() {
    const currentUser: User = JSON.parse(
      localStorage.getItem(LocalStorageKeys.USER) || '{}'
    );

    if (!currentUser || !currentUser.status) {
      this.router.navigate([RoutesKeys.ONBOARD]);
      return false;
    }

    if (!this.authenticatedUserService.representative) {
      return this.userService.getRepresentativeInfo().subscribe((rep) => {
        this.checkUserStatus(rep);
        return true;
      });
    } else {
      this.checkUserStatus(this.authenticatedUserService.representative);
      return true;
    }
  }

  /**
   * @param {Representative} representative
   */
  private checkUserStatus(representative: Representative) {
    if (representative.registerStatus === 'Pending') {
      this.router.navigate([
        `${RoutesKeys.ACCOUNT_MIGRATION}/${Routes.FINISH_ACCOUNT}`,
      ]);
    }
  }
}
